export default class CustomImageTool {
  private data: any;
  private wrapper: HTMLElement | null = null;

  static get toolbox() {
    return {
      title: "Image",
      icon: `<svg width="20" height="20" viewBox="0 0 20 20">
        <path d="M17 4H3a1 1 0 0 0-1 1v10a1 
        1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 
        1 0 0 0-1-1zm-1 10H4V6h12v8zM8 
        12l2 3 3-4 4 5H3l5-6z"/>
      </svg>`,
    };
  }

  constructor({ data }: any) {
    this.data = data || {};
  }

  render() {
    this.wrapper = document.createElement("div");

    if (this.data.file?.url) {
      this._renderImage(this.data.file.url);
    } else {
      this._renderButton();
    }

    return this.wrapper;
  }

  _renderButton() {
    if (!this.wrapper) return;
    this.wrapper.innerHTML = "";

    const button = document.createElement("button");
    button.type = "button";
    button.innerText = "Select from Gallery";
    button.className =
      "px-3 py-2 bg-blue-600 text-white rounded cursor-pointer";

    button.onclick = () => {
      const event = new CustomEvent("open-gallery-for-editor", {
        detail: {
          callback: (url: string) => {
            this.data = { file: { url } };
            this._renderImage(url);
          },
        },
      });
      window.dispatchEvent(event);
    };

    this.wrapper.appendChild(button);
  }

  _renderImage(url: string) {
    if (!this.wrapper) return;
    this.wrapper.innerHTML = "";

    const img = document.createElement("img");
    img.src = url;
    img.className = "max-w-full rounded my-2";

    this.wrapper.appendChild(img);
  }

  save(blockContent: HTMLElement) {
    const img = blockContent.querySelector("img");
    return {
      file: { url: img?.src },
    };
  }
}
